export default __webpack_public_path__ + "static/media/LZ_LetoKrov.a6cdd378.svg";